import r from "../managers/braze-instance.js";
import { MUST_BE_IN_APP_MESSAGE_WARNING as sr } from "../common/constants.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import se from "./in-app-message-manager-factory.js";
import { logger as N } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageButtonClick(o, t) {
  var e;
  if (!r.rr()) return !1;
  if (!(o instanceof InAppMessageButton))
    return N.error("button must be an InAppMessageButton object"), !1;
  if (!(t instanceof InAppMessage)) return N.error(sr), !1;
  const s = se.ea().Hi(o, t);
  if (s.tt)
    for (let r = 0; r < s.$e.length; r++)
      rt.m().Ce(
        ot.Qr,
        [
          t.triggerId,
          null === (e = o.id) || void 0 === e ? void 0 : e.toString(),
        ],
        s.$e[r],
      );
  return s.tt;
}
